import { ColDef } from 'ag-grid-community';
import { useMemo } from 'react';

import { AgGridTable, SlidingPanel } from 'core/components';
import { AgGridClientTableProvider, SelectionCountProvider } from 'core/states';
import { QuantityTotalsStatusBar } from 'parts/components/PartDetails/Inventory/QuantityTotalsStatusBar';

interface IProps<T extends { quantity: number }> {
  records: T[];
  columnDefs: ColDef[];
  tableId: string;
  entityType: string;
  title: string;
  onClose: () => void;
  isOpen: boolean;
}

const contentStyle = { width: 'min(1000px, 90vw)', paddingBottom: '16px' };

const statusBar = {
  statusPanels: [
    {
      statusPanel: QuantityTotalsStatusBar,
      align: 'left' as const,
    },
  ],
};

export const InventoryDetails = <T extends { quantity: number }>({
  records,
  columnDefs,
  tableId,
  entityType,
  title,
  onClose,
  isOpen,
}: IProps<T>) => {
  const dataWithIds = useMemo(
    () => records.map((row, index) => ({ ...row, id: index })),
    [records]
  );

  return (
    <SlidingPanel
      isOpen={isOpen}
      onClosePanel={onClose}
      title={title}
      autoWidth
      contentStyle={contentStyle}
    >
      <SelectionCountProvider>
        <AgGridClientTableProvider
          tableId={tableId}
          entityType={entityType}
          columnDefs={columnDefs}
          data={dataWithIds}
          dataCurrentPage={1}
          hasRowSelection={false}
          hasTopActions={false}
          sideBar={false}
          statusBar={statusBar}
        >
          <AgGridTable />
        </AgGridClientTableProvider>
      </SelectionCountProvider>
    </SlidingPanel>
  );
};
